














































































import VueI18n from 'vue-i18n';
import { defineComponent, computed, ref } from '@nuxtjs/composition-api';
import type { PropType } from '@nuxtjs/composition-api';
import { NotificationStatus } from '~/types/components/Notification/NotificationStatus';
import { ButtonTextSize } from '~/types/components/Buttons/ButtonTextSize';
import { notificationCssClasses } from '~/helpers/notifications/notificationCssClasses';
import Button from '~/components/atoms/Buttons/Button/Button.vue';

export default defineComponent({
  name: 'NotificationBanner',
  components: {
    Button,
  },
  props: {
    status: {
      type: String as PropType<NotificationStatus>,
      default: NotificationStatus.info,
    },
    title: {
      type: String,
      default: '',
    },
    subtitle: {
      type: String,
      default: '',
    },
    endingLinkText: {
      type: String,
      default: '',
    },
    endingLinkSlug: {
      type: String,
      default: '',
    },
    endingButtonText: {
      type: String,
      default: '',
    },
    dismissible: {
      type: Boolean,
      default: true,
    },
    shouldShow: {
      type: Boolean,
      default: false,
    },
    shouldShowIcon: {
      type: Boolean,
      default: true,
    },
    duration: {
      type: Number,
      default: 5000,
    },
    errorArray: {
      type: Array as PropType<string[] | VueI18n.TranslateResult[]>,
      default: () => [],
    },
  },
  setup(props) {
    const isActive = ref(true);
    const closeNotification = () => { isActive.value = false; };
    const isVisible = computed(() => isActive.value && (props.shouldShow || props.title || props.subtitle ||
      props.errorArray.length || props.endingLinkText || props.endingButtonText));

    const borderColor = computed(() => notificationCssClasses[props.status]?.border || '');
    const backgroundColor = computed(() => notificationCssClasses[props.status]?.background || '');
    const iconClass = computed(() => notificationCssClasses[props.status]?.icon || '');
    return {
      borderColor,
      backgroundColor,
      iconClass,
      ButtonTextSize,
      isVisible,
      closeNotification,
    };
  },
});
